import { UserTypes } from '../../SelfProvisioning/Constants/Constants'
import { INTEGRATION_TYPE, IntegrationType } from '../../TelSysConfiguration/Constants/Constants'

/**
 * Determines whether a staged user's monitoring scope must be its own device.
 *
 * <p>Only a Business telsys — one whose {@code IntegrationType} is
 * {@link INTEGRATION_TYPE.BUSINESS} — requires a Real-Time user (Professional
 * reporting access) to hold its own device as the monitoring scope. The backend
 * enforces this in {@code CReqRespUserAdd.ValidateScopeDeviceForUserType}: for
 * Professional it *requires* a device scope when the telsys integration type is
 * Business (error 11268), and *forbids* one otherwise (error 11227, "a user with
 * the assigned reporting access cannot have device assigned within
 * permissions").</p>
 *
 * <p>The telephony server type is deliberately not consulted. "Business" is an
 * integration-type property, not a telsys-type one, so BroadWorks, Webex and
 * Simulator telsys all take the backend's forbidden branch unless they carry the
 * Business integration type. Keying this off the telsys type instead made every
 * BroadWorks Professional create fail with 11227 (APD-13445).</p>
 *
 * @param userType Resolved provisioning user type.
 * @param integrationType Current telsys integration type (Teams legacy/business), or null for non-Teams.
 * @returns True when the monitoring scope must be the user's own device.
 */
export const requiresBusinessDeviceScope = (userType: string, integrationType: Nullable<IntegrationType>): boolean =>
    userType === UserTypes.PROFESSIONAL && integrationType === INTEGRATION_TYPE.BUSINESS
